import { TransportOrderIdView } from '../../../../models';

export class ShipmentTransportOrderEquipmentsLoad {
  constructor(public payload: TransportOrderIdView) {}
  public static readonly type = '[ShipmentTransportOrderEquipments] Equipments Load';
}

export class ShipmentTransportOrderEquipmentsInitialState {
  public static readonly type = '[ShipmentTransportOrderEquipments] Set Initial State';
}
